export const seedRequiredCompilationContextFields = compilationContext => {
  return {
    ...compilationContext,
    compilationContext: {
      ...compilationContext.compilationContext,
      webviewUrl: 'fakeurl.com',
      unsubscribeUrl: 'fakeurl.com',
      emailTrackingUnsubscribeUrl: 'fakeurl.com',
    },
  };
};
